<div class="common-view" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
	<ng-container *ngIf="data?.svgIcon || data?.icon">
		<mat-icon class="common-view-icon" fxLayoutAlign="center center" [svgIcon]="data?.svgIcon"
			[ngClass]="data?.iconClasses">
			{{data?.icon}}
		</mat-icon>
	</ng-container>
	<div fxLayout="column" fxLayoutAlign="start stretch">
		<label>{{data?.label}}</label>
		<ng-container *ngIf="data.type === 'text'">
			<ng-container *ngIf="![null,undefined].includes(data?.value)">
				<p [innerHtml]="data?.value | safeDom"></p>
			</ng-container>
		</ng-container>
		<ng-container *ngIf="data.type === 'chip'">
			<app-chips classes="capitalize" [type]="data?.chipData?.type" [data]="data?.chipData?.data">
			</app-chips>
		</ng-container>
	</div>
</div>
